module.exports = __webpack_public_path__ + "static/media/userIcon.fbf4acf4.svg";